import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-40079d74"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["element-loading-spinner"];
const _hoisted_2 = {
  class: "out_box"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "1rem",
    "cursor": "pointer"
  }
}, "返回", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title_box"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "catalog"
}, "目录")], -1));

const _hoisted_5 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%",
    "padding": "0 1rem 0 0"
  }
};
const _hoisted_6 = {
  style: {
    "color": "red",
    "font-weight": "bold"
  }
};
const _hoisted_7 = {
  class: "out_box"
};
const _hoisted_8 = {
  style: {
    "display": "flex",
    "width": "100%",
    "padding": "0 1rem 0 0",
    "align-items": "center"
  }
};
const _hoisted_9 = {
  style: {
    "font-weight": "bold",
    "user-select": "none"
  }
};
const _hoisted_10 = {
  style: {
    "user-select": "none"
  }
};
const _hoisted_11 = {
  class: "problem_box"
};
const _hoisted_12 = {
  class: "problem_title"
};
const _hoisted_13 = {
  class: "problem"
};
const _hoisted_14 = {
  class: "content_box"
};
const _hoisted_15 = {
  class: "recover_item"
};
const _hoisted_16 = {
  class: "toggle_language"
};
const _hoisted_17 = {
  class: "recover_content"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "recover_btn"
}, "回复", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_el_tree = _resolveComponent("el-tree");

  const _directive_loading = _resolveDirective("loading");

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "main",
    "element-loading-text": "Loading...",
    "element-loading-spinner": $data.svg,
    "element-loading-svg-view-box": "-10, -10, 50, 50",
    "element-loading-background": "rgba(122, 122, 122, 0.8)"
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    style: {
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.clickReturn())
  }, [_createVNode(_component_van_icon, {
    size: "20",
    name: "arrow-left"
  }), _hoisted_3]), _hoisted_4, _createVNode(_component_el_tree, {
    ref: "treeList",
    "node-key": "id",
    "highlight-current": "",
    data: $data.treeListData,
    props: $data.defaultProps,
    onNodeClick: $options.clickColumnData
  }, {
    default: _withCtx(({
      node,
      data
    }) => [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, _toDisplayString(data.name), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(data.sumNum), 1)])]),
    _: 1
  }, 8, ["data", "props", "onNodeClick"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_tree, {
    ref: "questionRef",
    "node-key": "id",
    data: $options.questionList,
    props: $data.questionDefaultProps,
    onNodeClick: $options.clickQuestionList
  }, {
    default: _withCtx(({
      node,
      data
    }) => [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(data.order_no) + ".", 1), _createElementVNode("span", _hoisted_10, _toDisplayString(data.label), 1)])]),
    _: 1
  }, 8, ["data", "props", "onNodeClick"])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString($data.questionTitle), 1)]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.answerList, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: "recover_box"
    }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, "语言：" + _toDisplayString(item.language), 1), _createElementVNode("p", _hoisted_17, _toDisplayString(item.order_no) + "." + _toDisplayString(item.content), 1), _hoisted_18])]);
  }), 128))])])])], 8, _hoisted_1)), [[_directive_loading, $data.loading]]);
}